// extracted by mini-css-extract-plugin
export default {"bold":"dCp0mz"};